import {
    ArrowRightIcon,
    EmailSubsectionChip,
    IconAuditTrail,
    IconCalendarPaid,
    IconScheduleTable,
    MobileIcon,
    TimePickerChip,
} from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import CustomChip from '../../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import {status, STATUS_MODEL} from '../../../../enums/statusEnum';
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat} from '../../../../Apis/functions';
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import routes from "../../../../Routes/routes";
import {TABLES} from "../../../../Apis/Tables";
import {useSelector} from "react-redux";
import React from "react";
import {permissionObj} from "../../../../Helpers/permission";
import ReservationUsersResume from "./ReservationUsersResume";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ReservationInformation = ({
    t,
    id,
    navigate,
    DEV,
    permission,
    isOverdue,
    userClassificationSelected,
    setUserClassificationSelected,
    setShowManagerUserListModal,
    containerHeight
}) => {
    const { eventDetail} = useSelector((state) => state?.EmployeeEventsSlice);
    const customStatusId = eventDetail.statusId === STATUS_MODEL.CANCELED ?
        eventDetail.statusId :
        isOverdue ? isOverdue: eventDetail.statusId;

    return (
        <>
            <div className="border-full-shades-300 border-radius-8px p-16px d-flex flex-column overflow-hidden minh-645px" style={{height:containerHeight }}>
                <div className={"row"}>
                    <div className='d-flex justify-content-between align-items-center p-3'>
                        <div className='d-flex align-items-center '>
                            <div><IconScheduleTable /></div>
                            <div className='ml-2'>
                                <CustomTooltip
                                    text={eventDetail.name}
                                    classes={'font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row'}
                                    showIfTruncated={true}
                                    placement={'top'}
                                />
                            </div>
                        </div>
                        <CustomChip
                            background={statusColor[customStatusId]}
                            fontColor={statusFontColor[customStatusId]}
                            borderColor={statusBorderColor[customStatusId]}
                            legend={t(status[customStatusId]) || EMPTY_VALUES.DEFAULT}
                            variant={'large'}
                        />
                    </div>
                </div>
                <div className={"border-full-shades-300 border-radius-8px flex-grow-1 min-h-0 d-flex flex-column overflow-y-auto"}>
                    <div className={"row"}>
                        <div className='d-flex align-items-center p-3'>
                            <IconAuditTrail />
                            <div className='ml-2'>
                                <CustomTooltip
                                    text={t('audit_trail')}
                                    classes={'font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row'}
                                    showIfTruncated={true}
                                    placement={'top'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='border-bottom-shades-300' />

                    <div className='row align-items-start p-3'>
                        <div className='col-2 p-0'>
                            <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center'>
                                <IconCalendarPaid/>
                            </div>
                        </div>
                        <div className='col-10'>
                            { (eventDetail.userEmail !== eventDetail.hostEmail) &&
                            <div>
                                <div className={"row"}>
                                    <CustomTooltip
                                        text={t('booking_created_by')}
                                        classes={'font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row p-0 mb-2'}
                                        showIfTruncated={true}
                                        placement={'top'}
                                        tooltipClasses={"p-0"}
                                    />

                                    <CustomTooltip
                                        text={eventDetail.userName}
                                        classes={`fs-14px font-color-general-950 text-ellipsis-1-row p-0`}
                                        showIfTruncated={true}
                                        tooltipClasses={"p-0"}
                                    />
                                </div>
                                <div className={"row mt-2"}>
                                    <div className={"d-flex justify-content-between p-0 gap-3"}>
                                        <div className={"d-flex flex-grow-1 minw-0 align-items-center"}>
                                            <div className={"mr-2 d-flex align-items-center"}>
                                                <EmailSubsectionChip/>
                                            </div>
                                            <div className={"flex-grow-1 minw-0"}>
                                                <CustomTooltip
                                                    text={eventDetail.userEmail}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row align-items-center`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                        { eventDetail.userPhoneNumber &&
                                        <div className={"d-flex flex-grow-1 minw-0"}>
                                            <div className={"mr-2 d-flex align-items-center"}>
                                                <MobileIcon className='icon-color-shades-800 flex-shrink-0' />
                                            </div>
                                            <div className={"flex-grow-1 minw-0"}>
                                                <CustomTooltip
                                                    text={eventDetail.userPhoneNumber}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div className='border-bottom-shades-300 my-3'/>
                            </div>
                            }

                            <div>
                                <div className={"row"}>
                                    <p className='fs-14px ibl-font-w-600 p-0 mb-2'>{t('host')}</p>
                                    <CustomTooltip
                                        text={`${eventDetail.hostName} ${eventDetail.hostLastName} ${eventDetail.hostSecondLastName || ''}`}
                                        classes={`fs-14px font-color-general-950 text-ellipsis-1-row p-0`}
                                        showIfTruncated={true}
                                        tooltipClasses={"p-0"}
                                    />
                                </div>
                                <div className={"row mt-2"}>
                                    <div className={"d-flex justify-content-between p-0 gap-3"}>
                                        <div className={"d-flex flex-grow-1 minw-0"}>
                                            <div className={"mr-2 d-flex align-items-center"}>
                                                <EmailSubsectionChip />
                                            </div>
                                            <div className={"flex-grow-1 minw-0"}>
                                                <CustomTooltip
                                                    text={eventDetail.hostEmail}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                        { eventDetail.hostPhoneNumber &&
                                        <div className={"d-flex flex-grow-1 minw-0"}>
                                            <div className={"mr-2 d-flex align-items-center"}>
                                                <MobileIcon/>
                                            </div>
                                            <div className={"flex-grow-1 minw-0"}>
                                                <CustomTooltip
                                                    text={eventDetail.hostPhoneNumber}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div className='border-bottom-shades-300 my-2'/>
                            </div>

                            <div className='row mt-3'>
                                <CustomTooltip
                                    text={t('approval_tracker')}
                                    classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row p-0 mb-2`}
                                    showIfTruncated={true}
                                    tooltipClasses={"p-0"}
                                />
                                <div className={"d-flex justify-content-end"}>
                                    <CustomChip
                                        background={statusColor[eventDetail.approvalStatusId]}
                                        fontColor={statusFontColor[eventDetail.approvalStatusId]}
                                        borderColor={statusBorderColor[eventDetail.approvalStatusId]}
                                        legend={ t(status[eventDetail.approvalStatusId]) || EMPTY_VALUES.DEFAULT}
                                        variant='large'
                                    />
                                </div>

                                <div className='d-flex justify-content-end p-0 my-3'>
                                    { ((DEV || (permission?.includes(permissionObj?.WEB_APPROVAL_FLOW_UPDATE) && permission?.includes(permissionObj?.WEB_APPROVAL_FLOW_READ))
                                    ) && eventDetail?.approvalFlowId ) &&
                                    <ButtonSubAction
                                        id='btn_ri_approval_tracker'
                                        name='view_approval_tracker'
                                        onClick={() => navigate(routes.approvalTracker.main + TABLES.EVENT + '/' + id + '/' + eventDetail?.approvalFlowId, {
                                            state:{ backUrl:{ pathname: routes.event.details + id, state: { isOverdue: isOverdue}}}
                                        })}
                                        Icon={ArrowRightIcon}
                                    />
                                    }
                                </div>

                                <div className='border-bottom-shades-300' />
                            </div>

                            <div className='row mt-3'>
                                <CustomTooltip
                                    text={eventDetail.reservationZoneName}
                                    classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row p-0 mb-2`}
                                    showIfTruncated={true}
                                />

                                <div className='d-flex flex-grow-1 minw-0 justify-content-between p-0'>
                                    <div className={"mr-2 d-flex align-items-center"}>
                                        <IconScheduleTable/>
                                    </div>
                                    <div className={"flex-grow-1 minw-0"}>
                                        <CustomTooltip
                                            text={`${t('from')} ${eventDetail.reservationFromTime} ${t('to').toLowerCase()} ${eventDetail.reservationToTime}`}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>

                                <p className='fs-14px font-color-shades-800 ibl-font-w-400 p-0 mt-2'>
                                    {getDateFormat(
                                        eventDetail.reservationDate,
                                        false,
                                        DATE_TIME_FORMAT_NAME_MODEL.shortMonth,
                                    )}
                                </p>

                                <div className='d-flex justify-content-between p-0  mt-2'>
                                    <div className={"mr-2 d-flex align-items-center"}>
                                        <TimePickerChip/>
                                    </div>
                                    <div className={"flex-grow-1 minw-0"}>
                                        <CustomTooltip
                                            text={`${t('duration')} ${eventDetail.duration} ${t('minutes').toLowerCase()}`}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                                <p className={"font-color-general-950 fs-14px mt-2"}>
                                    {'+'+eventDetail?.accessToleranceMin}
                                    &nbsp;&nbsp;
                                    {t("min_tolerance").toLowerCase()}
                                </p>
                            </div>

                            <ReservationUsersResume
                                userClassificationSelected={userClassificationSelected}
                                setUserClassificationSelected={setUserClassificationSelected}
                                setShowManagerUserListModal={setShowManagerUserListModal}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReservationInformation;
